import React, { Component } from 'react';
import apiClient from '../Utils/apiClient';
import { toastSuccess, toastError } from '../Utils/toast';
import { getUrlId } from '../Utils/responseHandler';
import _ from 'lodash';

export class SelectService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCompany: '',
            selectedService: '',
            selectedServiceStatus: '',
            statusEnabled: 'hide',
            companies: [],
            services: [],
            companyservices: [],
            label: '',
            messageSuccess: "",
            messageError: "",
            role: localStorage.getItem('userRole'),
            company_id: localStorage.getItem('companyId'),
            companyName: localStorage.getItem('companyName')
        }
    }

    availableServices = async (e) => {
        try {
            let res = await apiClient.get('services/');
            let resJson = res.data;
            this.setState({
                services: resJson.data,
            })
        } catch (error) {
            console.log(error);
        }
    }

    availableCompanies = async (e) => {
        try {
            let res = await apiClient.get('companies/');
            let resJson = res.data;
            this.setState({
                companies: resJson.data,
            })
        } catch (error) {
            console.log(error);
        }
    }

    fetchCompanyServices = (selectedCompany, selectedService) => {
        const companyId = selectedCompany;
        const serviceId = selectedService;
        console.log(companyId);
        console.log(serviceId);
        var body = {
            'company_id': companyId,
            'service_id': serviceId,
        };
        apiClient.post('companies/service-list', body)
            .then(response => {
                this.setState({ companyservices: response.data.data });
                this.setState({ statusEnabled: 'show' });
            })
            .catch(error => {
                this.setState({ statusEnabled: 'hide' });
                console.error('Error fetching data:', error);
            });
    }

    handleCompanyChange = (event) => {
        const selectedCompany = event.target.value;
        this.setState({ selectedCompany });
        this.setState({ selectedService: '' });
        this.setState({ selectedServiceStatus: '' });
        this.setState({ companyservices: [] })
    }

    handleServiceStatusChange = (e) => {
        console.log('Status');
        console.log(e.target.value);
        const selectedServiceStatus= e.target.value;
        this.setState({ selectedServiceStatus });
        console.log(this.state.selectedServiceStatus);
    }

    handleServiceChange = (event) => {
        const selectedService = event.target.value;
        const selectedCompany = this.state.selectedCompany;
        this.setState({ selectedService });
        this.fetchCompanyServices(selectedCompany, selectedService);
    }

    handleInputChange = (event, name) => {
        const { value } = event.target;
        const { companyservices } = this.state;

        const updatedData = companyservices.map(obj => {
            if (obj.name === name) {
                return { ...obj, value: value };
            }
            return obj;
        });

        this.setState({ companyservices: updatedData });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        let componyservicesfield = this.state.companyservices;
        let arrayextrafields = componyservicesfield.reduce((acc, obj) => {
            let { name, value } = obj;
            acc.push({ [name]: value });
            return acc;
        }, []);
        let requiredvalue = Object.assign({}, ...arrayextrafields);

        try {
            let res = await apiClient.post('companies/service', {
                service_id: this.state.selectedService,
                company_id: this.state.selectedCompany,
                status: this.state.selectedServiceStatus,
                extra_fields: requiredvalue
            });
            let resJson = res.data;
            if (resJson.error === false) {
                this.setState({ messageError: JSON.stringify(resJson.data) });
                toastError('Failed to save service integration');
            }
            if (resJson && resJson.success) {
                this.setState({ messageSuccess: "Company with Service has been registered!!" });
                toastSuccess('Service integration saved');
            }

        } catch (error) {
            console.log(error);
            this.setState({ messageError: error });
            toastError(error.response?.data?.message || 'Failed to save service integration');
        }
    }

    componentDidMount() {
        var companyId = _.isEmpty(getUrlId()) ? this.state.company_id : getUrlId();

        if ((!companyId || companyId) && this.state.role === 'Admin') {

            this.availableCompanies();
            this.availableServices();
            this.setState({ messageSuccess: "", selectedCompany: companyId });
        }
        if (companyId && this.state.role === 'customer') {
            this.setState({
                companies: [
                    {
                        "id": companyId,
                        "name_firma": this.state.companyName,
                    }
                ],
                selectedCompany: companyId
            });
            this.availableServices();
            this.setState({ messageSuccess: "" });
        }
    }
    render() {
        const { selectedCompany, selectedService,selectedServiceStatus, companies,statusEnabled, companyservices, services, messageError, messageSuccess } = this.state;
        const { label } = this.state.companyservices;
        console.log(companyservices);
        return (
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className='card'>
                        <div className='modal-header'>
                            <h6>Manage Service</h6>
                        </div>
                        <div className='container card-body'>
                            <div className='form-group'>
                                <div className='row'>
                                    <div className="col-lg-4">
                                        <label className="form-group-text">Company</label>
                                        <select className='form-control'
                                            value={selectedCompany}
                                            disabled={(selectedCompany && this.state.role !== 'Admin')}
                                            onChange={this.handleCompanyChange}
                                        >
                                            <option>Select Company</option>
                                            {
                                                companies.map((ele) => (
                                                    <option key={ele.id} value={ele.id}>{ele.name_firma}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-group-text">Service</label>
                                        <select className='form-control'
                                            value={selectedService}
                                            onChange={this.handleServiceChange}
                                        >
                                            <option>Select Service</option>
                                            {
                                                services.map((ele) => (
                                                    <option key={ele.id} value={ele.id}>{ele.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className={'col-lg-4 ' + statusEnabled }>
                                                <div className="form-group text-left">
                                                    <label className="form-group-text">Status</label>
                                                    <select className="form-select form-control"
                                                        name="status"
                                                        value={selectedServiceStatus}
                                                        onChange={this.handleServiceStatusChange}
                                                    >
                                                        <option value="true">Active</option>
                                                        <option value="false">In Active</option>
                                                    </select>
                                                    {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['status']}</span>}
                                                </div>

                                    </div>
                                </div>
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <div className='form-group'>
                                    <div className="message">
                                        {
                                            this.state.messageSuccess ? <p className='alert alert-success'>{this.state.messageSuccess}</p>
                                                : this.state.messageError ? <p className='alert alert-warning'>{this.state.messageError}</p>
                                                    : null
                                        }
                                    </div>
                                    {companyservices.length > 0 ? (
                                        <div className=''>
                                            {companyservices.map(item => (
                                                <div className='row' key={item.name} >
                                                    <div className='form-group col-lg-4'>
                                                        <label> {
                                                            (item.name.charAt(0).toUpperCase()
                                                                + item.name.slice(1)).replace('_', ' ')} </label>
                                                    </div>
                                                    <div className='form-group col-lg-8'>
                                                        <input
                                                            type="text"
                                                            key={item.name}
                                                            className="form-control"
                                                            name={item.name}
                                                            value={item.id ? item.value : label}
                                                            onChange={e => this.handleInputChange(e, item.name)}
                                                        />
                                                    </div>
                                                </div>

                                            ))}
                                        </div>

                                    ) : (
                                        <div className='col-lg-12'><div className='form-group'><p>No data to display.</p></div></div>
                                    )}
                                    <div className="">
                                        <button type="submit"
                                            className="btn btn-primary float-start"
                                        >Create</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
